import React, { useRef } from 'react'
import { SchButton } from '../../atoms'
import Wrapper from './style'

const SchTextInput = ({ref, placeholder, type, value, onChange, button, onClick, onKeyPress}) => {
	const getRef = useRef(ref)
	return (
		<Wrapper
			className={"rounded"}
		>
			<input
				placeholder={placeholder}
				type={type}
				value={value}
				onChange={onChange}
				onKeyPress={onKeyPress}
				ref={getRef}
			/>
			{button
				&& (
					<SchButton
						type="success"
						onClick={onClick}
					>
						Check ID
					</SchButton>
				)
			}
		</Wrapper>
	)
}

export default SchTextInput